import React, { useEffect, useState } from 'react';
import { Table, Input, Button, Breadcrumb } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { chauffeursService } from '../../common/services';
import { LoadableContent } from '../../components';
import { Link, useNavigate } from 'react-router-dom';
import { RightOutlined } from '@ant-design/icons';

const Chauffeurs = () => {
  const [chauffeurs, setChauffeurs] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();


  useEffect(() => {
    setLoading(true);
    chauffeursService.getAllChauffeurs()
      .then(setChauffeurs)
      .catch((err) => {
        console.error("Erreur lors du chargement des partenaires :", err);
        // alert("Impossible de charger les chants");
      })
      .finally(() => setLoading(false));
  }, []);

  // Filtrage par champ de recherche
  const filteredPartenaires = chauffeurs.filter((chauffeur) =>
    chauffeur.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
    chauffeur.id.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Colonnes du tableau
  const columns = [
    {
      title: 'Nom et Prénom',
      dataIndex: 'nom',
      key: 'nom',
      filters: [
        ...new Set(chauffeurs.map((chauffeur) => chauffeur.nom)),
      ].map((nom) => ({
        text: nom,
        value: nom,
      })),
      onFilter: (value, record) => record.nom === value,
      filterSearch: true,
      sorter: (a, b) => a.nom.localeCompare(b.nom),
    },
    {
      title: 'Numéro de Téléphone',
      dataIndex: 'phone',
      key: 'phone',
      filters: [
        ...new Set(chauffeurs.map((chauffeur) => chauffeur.phone)),
      ].map((phone) => ({
        text: phone,
        value: phone,
      })),
      onFilter: (value, record) => record.phone === value,
      filterSearch: true,
      sorter: (a, b) => a.phone.localeCompare(b.phone),
    },
    {
      title: 'Voiture',
      dataIndex: 'voiture',
      key: 'voiture',
      filters: [
        ...new Set(chauffeurs.map((chauffeur) => chauffeur.voiture)),
      ].map((voiture) => ({
        text: voiture,
        value: voiture,
      })),
      onFilter: (value, record) => record.voiture === value,
      filterSearch: true,
      sorter: (a, b) => a.voiture.localeCompare(b.voiture),
    },
    {
      title: 'Plaque',
      dataIndex: 'plaque',
      key: 'plaque',
      filters: [
        ...new Set(chauffeurs.map((chauffeur) => chauffeur.plaque)),
      ].map((plaque) => ({
        text: plaque,
        value: plaque,
      })),
      onFilter: (value, record) => record.plaque === value,
      filterSearch: true,
      sorter: (a, b) => a.plaque.localeCompare(b.plaque),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      filters: [
        ...new Set(chauffeurs.map((chauffeur) => chauffeur.status)),
      ].map((status) => ({
        text: status,
        value: status,
      })),
      onFilter: (value, record) => record.status === value,
      filterSearch: true,
      sorter: (a, b) => a.status.localeCompare(b.status),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Button
          type="primary"
          icon={<EyeOutlined />}
          size="small"
          onClick={() => navigate(`/dashboard/chauffeur/${record.id}`)}
        >
        </Button>
      ),
    },

  ];



  return (
    <LoadableContent isLoading={isLoading}>
      <div className="content-wrapper">
        <div className="container-xxl flex-grow-1 container-p-y">
          <div className="row">
            <div className="col-md-12">
              <Breadcrumb
                separator={<RightOutlined style={{ fontSize: '16px', color: '#999', fontWeight: 'bolder' }} />}
                style={{ marginBottom: 16 }}
              >
                <Breadcrumb.Item>
                  <Link to="/dashboard" style={{ fontSize: '16px', fontWeight: 'bolder' }}>🏠 Accueil</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <span style={{ fontSize: '16px', fontWeight: 'bolder' }}>👥 Chauffeurs</span>
                </Breadcrumb.Item>
              </Breadcrumb>
              <div className="card mb-4">
                <div className="card-body">
                  <div className="d-flex justify-content-end mb-3">
                    <Input
                      placeholder="Rechercher par titre ou auteur"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      style={{ width: 300 }}
                      allowClear
                    />
                  </div>
                  <Table
                    columns={columns}
                    dataSource={filteredPartenaires.map((partenaire) => ({
                      ...partenaire,
                      key: partenaire._id,
                    }))}
                    pagination={{ pageSize: 10 }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadableContent>
  );
};

export default Chauffeurs;
